import { MarketTypes } from "app/utils/const";
import groupBy from "lodash/groupBy";
import type { Element, Node } from "React";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { TranslationHelper } from "../../../../../../../../../../../helpers/translationHelper";
import type {
  EventMarketType,
  EventType,
} from "../../../../../../../../../../../types/eventType";
import "./ThreeWayMarketTypeSubheading.scss";
type Props = {
  event: EventType;
  market: EventMarketType;
  columnType: string;
};

class ThreeWayMarketTypeSubheading extends Component<Props> {
  // Some markets are grouped by type so headings must show the specific type and order
  renderTypeSubHeadings: () => Array<Node> = () => {
    const groupedRunners = groupBy(
      this.props.market.runners,
      this.props.columnType
    );
    const headings: Element[] = [];

    for (const type in groupedRunners) {
      headings.push(
        <FormattedMessage
          tagName="span"
          key={`${this.props.event.id}-${type}`}
          id={TranslationHelper.getTranslationIdForMarket(type)}
        />
      );
    }

    return headings;
  };
  // Markets based on the team side is always displayed as homeTeam, draw, awayTeam
  renderSideSubHeadings: () => Node = () => {
    const { market } = this.props;
    if (
      market.type === MarketTypes.RACE_TO ||
      market.type.indexOf("GOALSCORER") > -1 ||
      market.type.includes("TOUCHDOWN_SCORER")
    ) {
      return (
        <React.Fragment>
          <span key={"runner 1"}>{this.props.event.participant1}</span>
          <span key={"runner 2"}>{this.props.event.participant2}</span>
          <FormattedMessage tagName="span" id="events-neither" />
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <span key={"runner 1"}>{this.props.event.participant1}</span>
          <FormattedMessage tagName="span" id="events-draw" />
          <span key={"runner 2"}>{this.props.event.participant2}</span>
        </React.Fragment>
      );
    }
  };

  render(): Element<"div"> {
    const { market, columnType } = this.props;
    return (
      <div className={`${market.type.toLowerCase()} subheading threeway`}>
        {columnType === "type"
          ? this.renderTypeSubHeadings()
          : this.renderSideSubHeadings()}
      </div>
    );
  }
}

export default ThreeWayMarketTypeSubheading;
